<script setup>
  import { ref, onMounted, watchEffect } from "vue";
  import { computed } from "vue";
  import { useUserStore } from '@/stores/UserStore';

  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    spot: {
      type: Object,
      required: true
    }
  });

  const userStore = useUserStore();

  const favoriteId = ref(null);

  const spotSettings = computed(() => ({
    name: props.spot.name,
    lat: props.spot.lat,
    lon: props.spot.lon
  }));

  const isSpotFavorited = computed(() => favoriteId.value !== null);
  const buttonLabel = computed(() => isSpotFavorited.value ? "Unfavorite" : "Favorite");
  
  const checkIsSpotFavorited = () => {
    const favoritedSpot = userStore.isSpotFavoritedInCurrentProfile({spotId: props.spot.spot_id});

    favoriteId.value = favoritedSpot ? favoritedSpot[1] : null;
  };

  const handleFavoriteButtonClick = async (e) => {
    if (isSpotFavorited.value) {
      await userStore.removeSpotFromProfile(userStore.currentProfileId, favoriteId.value);
      favoriteId.value = null;
    } else {
      const response = await userStore.addSpotToProfile(userStore.currentProfileId, props.spot.spot_id, spotSettings.value);

      if (response.status_code === 0) {
        favoriteId.value = response.status_message;
      }
    }

    userStore.getProfiles(true);
  };

  onMounted(checkIsSpotFavorited);

  watchEffect(() => {
    if (props.spot.spot_id) {
      checkIsSpotFavorited();
    }
  });
</script>

<template>
  <Teleport to="[data-jwx-id='info-window-favorite']">
    <button
      class="jwx-info-window__favorite-button"
      @click.prevent.stop="handleFavoriteButtonClick"
    >
    <Transition mode="out-in">
      <span v-if="isSpotFavorited">
        <Icon
          name="star-solid"
          class="jwx-info-window__favorite-icon"
          :data-favorited="isSpotFavorited"
        />
      </span>
      <span v-else>
        <Icon
          name="star"
          class="jwx-info-window__favorite-icon"
          :data-favorited="isSpotFavorited"
        />
      </span>
      </Transition>
      <span class="sr-only">{{ buttonLabel }} Spot</span>
    </button>
  </Teleport>
</template>